import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        width: '100%',
        paddingTop: theme.spacing(2),
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        marginBottom: theme.spacing(4),
    },
    headerTitle: {
        fontSize: '1.75rem',
        fontWeight: 700,
    },
    body: {
        display: 'flex',
        alignItems: 'flex-start',
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        scrollBehavior: 'smooth',
        marginTop: theme.spacing(1),
        // Extend to the right page edge and bottom edge
        marginRight: theme.spacing(-3),
        paddingRight: theme.spacing(3),
        marginBottom: -24,
        paddingBottom: 200,
    },
    sidebarColumn: {
        position: 'sticky',
        top: 0,
        alignSelf: 'flex-start',
    },
    section: {
        flex: 1,
        minWidth: 0,
        paddingRight: theme.spacing(3),
    },
    sectionBlock: {
        paddingTop: theme.spacing(12),
        paddingBottom: theme.spacing(12),
        '&:first-of-type': {
            paddingTop: 0,
        },
    },
    sectionHeading: {
        fontSize: '1.35rem',
        fontWeight: 700,
        marginBottom: theme.spacing(3),
        color: theme.palette.text.primary,
    },
    sectionState: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 240,
    },
}));
